import { useQuery } from "@apollo/client/react";
import GET_CLIENTS_WITH_UPLOAD_UNITS from "../../queries/documentHandler/getClientsWithUploadUnits";
import type { InvoiceUploadUnitStatus } from "../../../models/InvoiceUploadUnitStatus";
import type { ClientWithUploadUnitsModel } from "../../../models/ClientInvoiceUploadUnitModel";

type ClientUploadUnitResponseType = {
  clientsWithUploadUnits: {
    totalCount: number;
    items: Array<ClientWithUploadUnitsModel>;
  };
};

export const useClientsWithUploadUnits = (
  missingClientIdentifier?: boolean,
  uploadUnitStatuses?: Array<InvoiceUploadUnitStatus>,
  clientIdentifier?: string,
  sortDirection?: "ASC" | "DESC",
  skip?: number,
  take?: number,
) => {
  const { data, error, loading, refetch } =
    useQuery<ClientUploadUnitResponseType>(GET_CLIENTS_WITH_UPLOAD_UNITS, {
      variables: {
        missingClientIdentifier: missingClientIdentifier,
        uploadUnitStatuses: uploadUnitStatuses,
        clientIdentifier: clientIdentifier,
        sortDirection: sortDirection,
        sortBy: "CREATED_AT",
        skip: skip,
        take: take,
      },
    });
  return {
    clientsWithUploadUnits: data?.clientsWithUploadUnits,
    error,
    loading,
    refetch,
  };
};
